import { useMemo } from 'react';
import { useCartStore } from '../../store/useCartStore';

export function useCartFooter() {
  const cartSyncStatus = useCartStore((s) => s.cartSyncStatus);
  const total_price = useCartStore((s) => s.total_price);
  const original_total_price = useCartStore((s) => s.original_total_price);
  const total_discount = useCartStore((s) => s.total_discount);
  const currency = useCartStore((s) => s.currency);
  const count = useCartStore((s) => s.count);

  const isEmpty = useMemo(() => count === 0, [count]);

  return {
    cartSyncStatus,
    total_price,
    original_total_price,
    total_discount,
    currency,
    count,
    isEmpty
  };
}
